import React from 'react';
import { useSelector } from 'react-redux';

import { Box, Tooltip } from '@mui/material';
import LabelCDS from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS';
import {
  LabelSize,
  LabelVariant,
} from 'app/shared/componentsRestyled/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { selectMasterCompany } from 'store/auth/selectors';

import { badgeSlotStyles } from './ExternalChannelBadge.styles';
import { getCompanyBadgeLabel, getExternalChannelTooltip } from './ExternalChannelBadge.utils';

const ExternalChannelBadge = () => {
  const companyName = useSelector(selectMasterCompany)?.name ?? null;
  const label = getCompanyBadgeLabel(companyName);

  return (
    <Tooltip title={getExternalChannelTooltip(companyName)}>
      <Box sx={badgeSlotStyles}>
        <LabelCDS size={LabelSize.S} title={label} variant={LabelVariant.ORANGE} />
      </Box>
    </Tooltip>
  );
};

export default ExternalChannelBadge;
